import { MypageNovelNovelIdGetInputModel } from "./GetInputModel"
import { MypageNovelNovelIdGetResponse } from "./GetResponse"
import { httpGet } from "../../../../../libs/http/httpGet"

const endpointUrl = `/v1/mypage/novel/{novelId}`

/** 小説情報の取得 */
export const getMypageNovelNovelId = (
  model: MypageNovelNovelIdGetInputModel,
): Promise<MypageNovelNovelIdGetResponse> => {
  return httpGet<MypageNovelNovelIdGetResponse>(endpointUrl, model)
}
